import formatLatePay from "./format_late_pay";

export const determineLatePayText = (nbrLatePays, oldestLatePay, mostRecentLatePay) => {
    let oldestLatePayText = "";
    let mostRecentLatePayText = "";
    if (nbrLatePays === 1){
        oldestLatePayText = formatLatePay(oldestLatePay, "Occurred", "ago");
    }else{
        oldestLatePayText = formatLatePay(oldestLatePay, "Oldest late payment: ");
        mostRecentLatePayText = formatLatePay(mostRecentLatePay, "Most Recent late payment: ");
    }
    const returnObj = {oldestLatePayText: oldestLatePayText, mostRecentLatePayText: mostRecentLatePayText};
    return returnObj;
}
export default determineLatePayText;